import { render } from "./EmployeeLanguages.vue?vue&type=template&id=9691dcd8&scoped=true"
import script from "./EmployeeLanguages.vue?vue&type=script&lang=js"
export * from "./EmployeeLanguages.vue?vue&type=script&lang=js"

import "./EmployeeLanguages.vue?vue&type=style&index=0&id=9691dcd8&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9691dcd8"]])

export default __exports__